<div class="modal-header" *ngIf="dismiss">
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<iframe [attr.src]="url|safe"></iframe>
